// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1rcux","row":"ProcedureTreatmentSummary_row__28cdE"};